export { default as canIUseDOM } from './canIUseDOM';
export { default as createInstanceScope } from './createInstanceScope';